import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment/min/locales';
import { View, ScrollView, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { Tabs, Tab } from '@dbk/ui-tabs';
import { Refresh , Timepicker , Info2 } from '@dbk/ui-icons';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import { Toast } from '@dbk/ui-notifications'
import Text, { Large } from '@dbk/ui-text';
import isEmpty from 'lodash/fp/isEmpty';
import { CUSTOM_REPORT_SELECTED_RANGE } from '../../../../@extension/CH/src/screens/reports/constants';
import { ChangeIndicatedCurrency } from '../../../components/common/number';
import additionalStyles from '../../data-exports/custom-transactions.styles';
import { LoadingCircle } from '../../../components/common/loading';
import { PALETTE , BRANCH_CODE , DATE_AVALOQ} from '../../../constants';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import { currentDateText } from '../../../utils/date';
import { FormattedMessage } from '@dbk-legacy/format';
import { Radio } from '@dbk/ui-forms';
import { IconButton } from '@dbk/ui-buttons';
import { QuestionMark } from '../../../components/common/icons';
import InverseProvider from '@dbk/ui-inverse';
import Button from '@dbk/ui-buttons';
import { Currency } from '../../../../src/components/common/number';
import Popover from '../../../components/popover-component';
import { formatDate } from '../../../../@extension/CH/src/screens/reports/report-utils';

const today = moment().format('YYYY-MM-DD');
const weekAgo = moment().subtract(6, 'd').format('YYYY-MM-DD');
const monthAgo = moment().subtract(30, 'd').format('YYYY-MM-DD');
const trimonthAgo = moment().subtract(3, 'months').format('YYYY-MM-DD');
const currentYearDate = moment().startOf('year').format('YYYY-MM-DD');
const firstDayOfYear = moment().startOf('year');
class SummaryCashAccountsDetails extends PureComponent {

  constructor(props) {
    super(props);
    const languageCode = this.props.auth.langCode;
    Utils.configLocale(languageCode, {
      week: {
        dow: 1
      },
    });

    const asOfDate = moment().format('DD-MM-YYYY');
    
    this.state = {
     selectedTab: 0,
     showCurBalPopover : false,
     value: {
      from: moment(currentYearDate, "DD-MM-YYYY"),
      to: moment(asOfDate, "DD-MM-YYYY")
  },
    selectedViewByDate: this.props.cashAccounts.bookingDateType || '',
    showTotalMktValPopover: false,
    startDate: this.getStartDate(this.props.selectedPortfolioData.branchCode.toString())
    };

    this.props.setFromDate(weekAgo);
    this.props.setEndDate(today);
  }

  componentDidMount() {
    this.props.cashAccountBookings();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedPortfolioData &&
      this.props.selectedPortfolioData.id !== nextProps.selectedPortfolioData.id
    ) {
      this.props.goBack();
      this.props.cashAccountBookings();
    } 
  }

  componentWillUnmount() {
    this.props.setcashAccountData({});
    this.props.setbookings({});
    this.props.setLoading(false);
  }

  handleCurBalancePopover = (value) => {
     this.setState({ showCurBalPopover: value });
  }

  componentDidUpdate(prevProps , prevState) {
  if( this.state.selectedViewByDate !== prevState.selectedViewByDate){
      const value= this.state.selectedViewByDate
      this.props.setBookingDateType(value);
      this.props.cashAccountBookings();
      } 
  }
//WMCE-36301- Introducing View By 
  onRadioSelectedViewByDate(value){
    this.setState({selectedViewByDate: value});
    this.props.setBookingDateType(value);
  }

getStartDate(branchCode){   //WMCE-36301-for setting calender starting date as region- wise avaloq go live date 
  switch(branchCode){
    case BRANCH_CODE.branchCodeCH : 
      return moment(DATE_AVALOQ.dateCH,'DD.MM.YYYY');
    case BRANCH_CODE.branchCodeUK :
      return moment(DATE_AVALOQ.dateUK,'DD.MM.YYYY');
    case BRANCH_CODE.branchCodeLUX :
      return moment(DATE_AVALOQ.dateLux,'DD.MM.YYYY');
    default :
      return moment(DATE_AVALOQ.defaultDate,'DD.MM.YYYY');
  }
}

  onSelectTime(selectedTab) {
    const { setFromDate, setEndDate, cashAccountBookings, setbookings } = this.props;
    this.setState({
      selectedTab
    });
    setbookings({});
    if (selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM) {
      setFromDate(currentYearDate);
      setEndDate(today);
      this.setState({
        value: {
          from:moment(firstDayOfYear.format('DD-MM-YYYY'), "DD-MM-YYYY"),
          to:moment(moment().format('DD-MM-YYYY'), "DD-MM-YYYY")
        }
     });
    }

    switch (selectedTab) {
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_WEEK:
        setFromDate(weekAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_MONTH:
        setFromDate(monthAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.PAST_THREE_MONTHS:
        setFromDate(trimonthAgo);
        break;
      default:
        break;
    }
    setEndDate(today);
    cashAccountBookings();
  }

  renderRows(rows, langCode) {
    return rows.map((row, index) => {
   const valueDate = moment(row.valueDate,'MMM DD,YYYY').format('YYYY-MM-DD');  //WMCE-36301- For comparing value date with today's date 
   const receivedDate = row.valueDate ? formatDate(row.valueDate, langCode): "";
   const newTxnDate = row.txnDate ? formatDate(row.txnDate, langCode): "";
   const isFutureDate= moment(valueDate).isAfter(today);
   const isFutureValueDate=(this.state.selectedViewByDate==='VALUE' && isFutureDate);
   const textStyle={color:isFutureValueDate ? PALETTE.warning: null, fontStyle:isFutureValueDate ? 'italic': null};
   const bookingType= row.bookingType === 'CUSTOM' ? additionalStyles.rootCustom : additionalStyles.root
   return(
      
      <View style={StyleSheet.flatten(bookingType)} key={`${index}+1`}>
        <View style={StyleSheet.flatten(additionalStyles.container)}>
          {
          this.state.selectedViewByDate==='VALUE' ? 
          
          <View style={additionalStyles.firstContainer}>
          <View style={StyleSheet.flatten(additionalStyles.listItemStart)}>
            <Text style={textStyle}>{receivedDate}</Text>
            {isFutureValueDate && <div style={{marginLeft:10}}><Timepicker color={PALETTE.warning}></Timepicker></div>}
          </View>
          <View style={additionalStyles.listItemStart}>
            <Text style={textStyle} >{newTxnDate}</Text>
          </View>
          </View>
          :
          <View style={additionalStyles.firstContainer}>
          <View style={StyleSheet.flatten(additionalStyles.listItemStart)}>
            <Text>{newTxnDate}</Text>
          </View>
          <View style={additionalStyles.listItemStart}>
            <Text>{receivedDate}</Text>
          </View>
          </View>
          }
          <View style={additionalStyles.listItemFirst}>
            <Text style={textStyle}>{row.description} </Text>
          </View>
          <View style={additionalStyles.listItemReference}>
            <Text secondary style={textStyle}>{row.reference}</Text>
          </View>
          <View style={additionalStyles.listItem}>
            {(!row.debit || row.debit === null || row.debit === undefined || row.debit === 0) ?
              <Text></Text> : (
                <div>
                  <ChangeIndicatedCurrency
                    value={parseFloat(row.debit)}
                   renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate}}
                    onlyNegativeStyling
                    currency={row.ccyTrade}
                  />
                </div>
              )}
          </View>
          <View style={additionalStyles.listItem}>
            {(!row.credit || row.credit === null || row.credit === undefined || row.credit === 0) ?
              <Text></Text> : (
                <div>
                  <ChangeIndicatedCurrency
                    value={parseFloat(row.credit)}
                    renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate }}
                    onlyNegativeStyling
                    currency={row.ccyTrade}
                  />
                </div>
              )}
          </View>
          <View style={additionalStyles.listItem}>
            {row.balance === null ? (
              '-'
            ) : (
              <div>
                <ChangeIndicatedCurrency
                  value={parseFloat(row.balance)}
                 renderProps={{ size: 'small', style: additionalStyles.date, color: PALETTE.secondaryActive ,isFutureValueColor:isFutureValueDate}}
                  onlyNegativeStyling
                  currency={row.ccyTrade}
                />
              </div>
            )}
          </View>
        </View>
      </View>
    );});
  }

  onDateClicked = (selectionStart) => {
    const { setFromDate, setEndDate, cashAccountBookings } = this.props;
        this.setState({
     value: {
      ...Utils.updateRangeWithReset(this.state.value, selectionStart)
    }
    });
    setFromDate(selectionStart.from.format('YYYY-MM-DD'))
    setEndDate(selectionStart.to.format('YYYY-MM-DD'))
  };
  
  onRefreshClick = () => {
    this.props.cashAccountBookings();
  }

  onApplyDateChange = () => {
    const { setFromDate, setEndDate, cashAccountBookings } = this.props;
    setFromDate(this.state.value.from.format('YYYY-MM-DD'))
    setEndDate(this.state.value.to.format('YYYY-MM-DD'))
    cashAccountBookings();
    this.onCancel();
  }


  onCancel = () => {
    this.datepickerRef.datepicker.closeCalendar();
    this.props.setDatePickerClose(false);
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "65px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div style={{ width: "45%", display: "inline-grid", float: 'left' }}>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='calenderFooterButton'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
        disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

  render() {
    const {
      i18n: { messages },
      cashAccounts: { bookings, fromDate, endDate, cashAccountData, isLoading, bookingsHasMore },
      languages: { destLanguage },
      auth: { langCode },
    } = this.props;

    const { selectedTab , showCurBalPopover} = this.state;
    const bookingList = !isEmpty(bookings) ? bookings.bookingList : [];
    const filterCashList = !isEmpty(cashAccountData) ? cashAccountData : [];
    const currentDate = moment(moment().format('DD-MM-YYYY'), "DD-MM-YYYY");
    const startDate = moment(this.state.startDate.format('DD-MM-YYYY'), "DD-MM-YYYY");
    const bookingListLength = bookingList && bookingList.length - 2;
    const curBalSign = Math.sign(filterCashList.balance);    //WMCE-36301-38474--To display negative current balance and accured interest in red color
    const curBalStyleColor = curBalSign === -1 ? additionalStyles.negativeDate : additionalStyles.date ;
    const curBalDecimalStyle = curBalSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;
    const accInterestSign = Math.sign(filterCashList.accruedInterest)
    const accInterestStyleColor = accInterestSign === -1 ? additionalStyles.negativeDate : additionalStyles.date ;
    const accInterestDecimalStyle = accInterestSign === -1 ? additionalStyles.negativeDecimalStyle : additionalStyles.decimalStyle;

    return (
      <div >
        <div>
          <div className="row large-collapse">
            <div className="profile-container">
              <div id="cash_account_header" className="cash_account_header">
                <div className='header-main'>{filterCashList.name}</div>
                <div className='header-child'>
                  <div><label>{messages['app.cashAccounts.label.iban']}: </label>{filterCashList.iban}</div>
                  <div><label>{messages['app.common.pageTitle.portfolio']}: </label>{filterCashList.pfId}</div>
                </div>
                <div className='header-child-cur-bal'>
                 
                  <div style={StyleSheet.flatten(additionalStyles.curBalDiv)}>
                    <label style={StyleSheet.flatten(additionalStyles.curBalLabel)}>{messages['app.cashAccounts.label.currentBalance']}: </label>   
                    <span>
                    <Currency
                     signBeforeNumber={false}
                     decimalStyle={curBalDecimalStyle}
                     currencyStyle={additionalStyles.currencyStyleHeader}
                     currency={filterCashList.cashAccCurrency}
                     renderProps={{ style: curBalStyleColor, color: PALETTE.secondaryActive }} 
                     value= { (filterCashList.balance) ? filterCashList.balance: 0}
                     />
                  </span>
                  <div style={StyleSheet.flatten(additionalStyles.curBalDivPopover)}> 
                  <Popover
                   mode="popup"
                   orientation="top"
                   showOnHover
                   popOverClassName="cur-bal-popover"
                   arrowColor={PALETTE.secondaryActive}
                  content={<div>{messages["app.cashAccounts.summary.curBalancePopoverContent"]}</div>}
                  >
                 <Info2 color={PALETTE.fordGray} height={29} width={29}/>
                 </Popover>
                 </div>
                </div>
                  
                <div>
                  <label>{messages['app.common.portfolio.bondsAsset.accInt']}: </label>
                   <Currency
                    signBeforeNumber={false}
                    decimalStyle={accInterestDecimalStyle}
                    currencyStyle={additionalStyles.currencyStyleHeader}
                    currency={filterCashList.cashAccCurrency}
                    renderProps={{ style: accInterestStyleColor, color: PALETTE.secondaryActive }} 
                    value= {(filterCashList.accruedInterest) ? filterCashList.accruedInterest:0}
                    />           
                  </div>
                </div>
                
                  <div className={destLanguage === "Deutsch" ? "header-child1-lang" : "header-child1"}>
                    <div>
                      <label>{messages['app.cashAccounts.label.viewBy']}:</label>
                    </div>
                 </div>
                  <div>
                    <div className='radio-header'>
                       <Radio
                          className= "transactionDateRadioButton"
                          label=
                            {messages['app.cashAccounts.label.transactionDate']}
                          value= "TRANSACTION"
                          checked={this.state.selectedViewByDate === "TRANSACTION" || this.state.selectedViewByDate === ''}
                          onChange={()=>this.onRadioSelectedViewByDate("TRANSACTION")}
                        
                        />
                    </div> 
                    <div>  
                        <Radio
                          className= "valueDateRadioButton"
                          label= {messages['app.cashAccounts.label.valueDate']}
                          value= "VALUE"
                          checked={this.state.selectedViewByDate === "VALUE"}
                          onChange={()=>this.onRadioSelectedViewByDate("VALUE")}
                        />
                    </div>  
                    </div>
                
              </div>
              {bookingsHasMore && <Toast underline status="information"
                className='toastCashAccount'
                onClose={() => this.props.setBookingsHasMore(false)}>
                <FormattedMessage
                  id={'app.cashAccounts.warning.exceedResult'}
                  values={{ bookingListLength }} />
              </Toast>}
              <View className='tab_cashAccount'>
                <Tabs
                  secondary
                  stretch
                  handleSelectedIndex={index => this.onSelectTime(index)}
                  selectedIndex={selectedTab}
                >
                  <Tab className='tab_cashAccount_column' testID="tab_cashAccount_7days_cashAccountDetails_test" renderLabel={() => messages['app.incomehistory.7days']} />
                  <Tab className='tab_cashAccount_column' testID="tab_cashAccount_30days_cashAccountDetails_test" renderLabel={() => messages['app.report.transactionHistory.30days']} />
                  <Tab className='tab_cashAccount_column' testID="tab_cashAccount_3months_cashAccountDetails_test" renderLabel={() => messages['app.report.transactionHistory.90days']} />
                  <Tab className='tab_cashAccount_column' testID="tab_cashAccount_date_cashAccountDetails_test" renderLabel={() => messages['app.maturities.overview.tabs.labels.custom']} />
                </Tabs>
              </View>

              <div className="row">
                <div id="text_cash_account_header_test" className="text_cash_account_show columns small-6 medium-7 large-9 padding-bottom-10">
                <span className="refreshIcon" onClick={this.onRefreshClick} >
                  <Refresh className="refreshIcon" id="refresh" width={30} height={30} color={PALETTE.primaryText} />
                </span>
                  {/* <GenericDateSelectionBar
                    text={currentDateText(fromDate.toString(), endDate.toString(), messages)}
                  /> */}
                </div>
                <span className="columns small-6 medium-5 large-3 ">
                  {selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM &&
                    <div className="customReportCalendar">
                      <View id="datepicker_cash_account_details" className="calendarContainer">
                         {!this.props.logoutPopup.isVisible && <DatePicker
                           ref={(ref) => this.datepickerRef = ref}
                           showOutsideMonthDays={false}
                           canChangeMonth
                           enableYearNavigation
                           enableRangeSelection
                           onChange={this.onDateClicked}
                           value={this.state.value}
                           endDate={currentDate}
                           startDate={startDate}
                           inputDateFormat={'DD MMM YYYY'}
                           renderFooter={() => this.customFooter()}
                        />}
                      </View>
                    </div>
                  }  </span>
              </div>
            </div>
          </div>
        </div>

        <View className="container_cash_account">
          {
            <View>
              {isLoading === true ?
               <View style={StyleSheet.flatten(additionalStyles.loadingData)}><LoadingCircle /></View>
                :
                <div id="container_cash_account_details_test">
                  {bookingList && bookingList.length > 0 ?
                    <div><View style={StyleSheet.flatten(additionalStyles.headerRoot)}>
                     <View style={StyleSheet.flatten(additionalStyles.container)}>
                      
                      {this.state.selectedViewByDate === 'VALUE' ?
                       <View style={StyleSheet.flatten(additionalStyles.firstContainer)}>
                         <View style={StyleSheet.flatten(additionalStyles.listItemStart)}>
                          <Text secondary style={{color:PALETTE.primaryActive}}>{messages['app.report.transactionHistory.valueDate']}</Text>
                        </View>
                        <View style={additionalStyles.listItemStartNext}>
                          <Text secondary>{messages['app.common.portfolio.bonds.transDate']}</Text>
                        </View> 
                        </View> :
                        <View  style={StyleSheet.flatten(additionalStyles.firstContainer)}>
                        <View style={StyleSheet.flatten(additionalStyles.listItemStart)}>
                        <Text secondary style={{color:PALETTE.primaryActive}}>{messages['app.common.portfolio.bonds.transDate']}</Text> 
                        </View>
                        <View style={additionalStyles.listItemStartNext}>
                        <Text secondary>{messages['app.report.transactionHistory.valueDate']}</Text>
                        </View>
                        </View> }
                        <View style={additionalStyles.listItemFirst}>
                          <Text secondary>{messages['app.report.transactionHistory.desc']}</Text>
                        </View>
                        <View style={additionalStyles.listItemReference}>
                          <Text secondary>{messages['app.chedelivery.reports.customReports.txn.reference']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.cashAccounts.debit']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.common.pageTitle.credit']}</Text>
                        </View>
                        <View style={additionalStyles.listItem}>
                          <Text secondary>{messages['app.common.portfolio.bonds.balance']}</Text>
                        </View>
                      </View>
                    </View>
                      <div className="scrollBarHoverCash">
                        <ScrollView
                          className="scrollBarHideCash" id="scrollBarHide"
                          ref={r => this.rootView = r}
                        >{this.renderRows(bookingList, langCode)}
                        </ScrollView>
                      </div>
                    </div>
                    :
                     //WMCE-40317- To fix datepicker positioning issue in case of no record
                    <div className="noRecordScreen">  
                    <div className="text-center margin-top-20">
                      <Large secondary> {messages['app.reports.noRecords']}</Large>
                    </div>
                    <div className="restScreen"></div>
                    </div>
                  }
                </div>
              }
            </View>
          }
        </View>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    languages: {
      destLanguage: true
    },
    cashAccountBookings: { $call: 'cashAccounts.bookingList' },
    setFromDate: { $set: 'cashAccounts.fromDate' },
    setBookingDateType : { $set: 'cashAccounts.bookingDateType' },
    setbookings: { $set: 'cashAccounts.bookings' },
    setcashAccountData: { $set: 'cashAccounts.cashAccountData' },
    setEndDate: { $set: 'cashAccounts.endDate' },
    setLoading: { $set: 'cashAccounts.isLoading' },
    setBookingsHasMore: { $set: 'cashAccounts.bookingsHasMore' },
    cashAccounts: {
      cashAccountData: true,
      bookings: true,
      fromDate: true,
      endDate: true,
      isLoading: true,
      positionObjId: true,
      bookingsHasMore: true,
      bookingDateType :true,
    },
    setRange7Days: {
      $call: 'cashAccounts.setRange7Days'
    },
    setRange30Days: {
      $call: 'cashAccounts.setRange30Days'
    },
    setRange3Months: {
      $call: 'cashAccounts.setRange3Months'
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
    app: {
      user: {
        selectedPortfolioData: true
      },
    },
    auth: {
      langCode: true,
    },
    logoutPopup: { isVisible: true },
    goBack: { $call: 'ui.history.goBack' },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  selectedPortfolioData: app.user.selectedPortfolioData
}))(SummaryCashAccountsDetails);

export { SummaryCashAccountsDetails };
